import {
  World,
  MovementSystem,
  RenderSystem,
  CollisionSystem,
  InputManager,
} from '@badideagames/engine';
import { FlapSystem } from './systems/FlapSystem';
import { GravitySystem } from './systems/GravitySystem';
import type Phaser from 'phaser';

export class Game {
  readonly world: World;
  readonly input: InputManager;
  readonly collisionSystem: CollisionSystem;

  constructor(scene: Phaser.Scene) {
    this.world = new World();
    this.input = new InputManager(scene);
    this.collisionSystem = new CollisionSystem();

    // System order: input → physics → movement → collision → render
    this.world.addSystem(new FlapSystem(this.input));
    this.world.addSystem(new GravitySystem());
    this.world.addSystem(new MovementSystem());
    this.world.addSystem(this.collisionSystem);
    this.world.addSystem(new RenderSystem(scene));
  }

  update(delta: number): void {
    this.world.update(delta);
    this.input.update(); // Clear pressed/released state after systems have read it
  }

  destroy(): void {
    this.input.destroy();
    this.world.destroy();
  }
}
